/* eslint-disable */
import { RequestAccess, RequestAccessConverter } from '@/firebase/models/request_access_model'
import { db, Timestamp, } from "@/firebase/config"
import { collection, addDoc } from "firebase/firestore"

/**
 * Class to add mock access requests
 */
const addMockAccessRequests = () => {
    
    /**
     * Adds the mock Access requests
     * @returns {Promise<void>}
     */
    const addRequests = async () => {
        for (const req of _createMockAccessRequests()) {
            await addDoc(collection(db, 'RequestAccess').withConverter(RequestAccessConverter), req)
        }
    }

    /**
     * Creates the list of new access requests.
     * @returns {RequestAccess[]}
     */
    function _createMockAccessRequests() {
        return [
            new RequestAccess(
                'John',
                'Doe',
                'john_doe',
                'test@testing.com',
                'Coshocton County',
                'Coshocton',
                Timestamp.now(),
                false,
            ),
            new RequestAccess(
                'Janet',
                'Test',
                'jTest123',
                'user@testing.com',
                'Coshocton County',
                'Ridgewood',
                Timestamp.now(),
                false,
            ),
            new RequestAccess(
                'Bear',
                'Dog',
                'Bear12',
                'bear@dog.com',
                'Perry County',
                'Perry Madison',
                Timestamp.now(),
                false,
            ),
        ]
    }

    return { addRequests }
}

export default addMockAccessRequests
